import React from 'react';
import styles from './style.module.css';
const LogoutButton = ({ name, logout, resetState }) => {
  const logoutClick = () => {
    localStorage.setItem('isRedirectToStore', 0);
    logout();
    resetState();
  };

  return (
    <>
      <button onClick={() => logoutClick()} className={styles.button}>
        {name}
      </button>
    </>
  );
};
export default LogoutButton;
